import type { SxProps } from '@mui/material';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { Card, CardHeader, CardContent, Typography, Avatar } from '@packages/shared';
import { ServiceConsulting32 } from '@packages/themes/icons';

const ResponseFragment = graphql(/* GraphQL */ `
  fragment ResponseFragment on Response {
    author
    created
    title
    description
  }
`);

type ResponseProps = {
  /**
   * Response data with author, created, description and title
   */
  responseData: FragmentType<typeof ResponseFragment>;
  /**
   * MUI SxProps
   */
  sx?: SxProps;
};

export const Response = ({ responseData, sx }: ResponseProps) => {
  const { author, created, title, description } = getFragmentData(ResponseFragment, responseData);
  return (
    <Card variant="outlined" sx={{ borderColor: 'grey.main', ...sx }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'grey.light', width: 28, height: 28 }}>
            <ServiceConsulting32 sx={{ color: 'text.darkTransparent', fontSize: '1.5rem' }} />
          </Avatar>
        }
        title={author}
        subheader={created}
        sx={{ p: 1, pb: 0.5, '.MuiCardHeader-avatar': { mr: 1.25 } }}
        titleTypographyProps={{ fontWeight: 'fontWeightSemiBold' }}
      />
      <CardContent sx={{ p: 1, pt: 0, ':last-child': { pb: 2 } }}>
        <Typography variant="body2" fontWeight="fontWeightSemiBold">
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </CardContent>
    </Card>
  );
};
